module.exports = __webpack_public_path__ + "static/baranski-optimo-03101b1b0d00d95107f916c1ba9c572d.svg";